import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CookieConsent = () => {
  const [show, setShow] = useState(() => !localStorage.getItem("ucmp_cookie_consent"));
  if (!show) return null;
  const accept = () => { localStorage.setItem("ucmp_cookie_consent", "1"); setShow(false); };
  return (
    <div data-testid="cookie-consent" className="no-print fixed bottom-4 inset-x-4 sm:left-auto sm:right-4 sm:max-w-md z-50 rounded-xl border border-zinc-700 bg-zinc-900/95 backdrop-blur p-4 shadow-2xl">
      <div className="flex items-start gap-3">
        <Cookie className="h-5 w-5 text-amber-400 shrink-0 mt-0.5" />
        <div className="text-[13px] text-zinc-300 leading-relaxed">
          We use essential cookies and collect basic usage analytics (page, device, and approximate location from your IP) to run and improve UC Engineer Pro. See our{" "}
          <Link to="/privacy" className="text-blue-400 hover:text-blue-300 underline">Privacy Policy</Link>.
        </div>
      </div>
      <div className="mt-3 flex justify-end">
        <button onClick={accept} data-testid="cookie-accept-btn" className="text-[13px] font-semibold px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white">
          Got it
        </button>
      </div>
    </div>
  );
};
